import { map, reduce } from 'ramda';
import { QStylesQuery } from '../_graphql/queries/documents/QStyles';
import useFetchQuery from './useFetchQuery';

const useStyles = (env) => {
  const { styles: customStyles, reFetch } = useFetchQuery({
    query: QStylesQuery,
    args: { scope: 'global' },
    dataProp: 'styles',
    defaultData: [],
    env
  });

  const styles = map(({ id, name, styles, uuid }) => ({
    id,
    name,
    uuid,
    styles: reduce(
      (acc, { format, value }) => ({
        ...acc,
        [format]: value
      }),
      {},
      styles
    )
  }))(customStyles);

  return { styles, reFetch };
};

export default useStyles;
